import {clearLocalStorage} from '../../util/storage'

export const logOut = (history, isTokenExpired = false) => {
  clearLocalStorage()
  history.push('/')
  return {
    type: 'LOG_OUT',
    payload: {
      isTokenExpired,
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/logout/actions.js